<script setup>
import ManualList from '@/Pages/Dashboard/Manuals/Partials/ManualList.vue';
import FeatureManualList from '@/Pages/Dashboard/Manuals/Partials/FeatureManualList.vue';
import SearchField from '@/components/Dashboard/SearchField.vue';
import { router } from '@inertiajs/vue3';

const props = defineProps({
  suggestedManuals: {
    type: Array,
    required: true,
  },
  allManuals: {
    type: Array,
    required: true,
  },
  allFeatureManuals: {
    type: Array,
    required: true,
  },
  search: {
    type: String,
    default: null,
  },
});

const handleSearch = searchValue => {
  router.get(
    route('dashboard.manuals.index'),
    { search: searchValue },
    {
      preserveState: true,
      preserveScroll: true,
      only: ['allManuals', 'suggestedManuals'],
    },
  );
};
</script>

<script>
import ManualsLayout from '@/Layouts/ManualsLayout.vue';

export default {
  layout: ManualsLayout,
};
</script>

<template>
  <div class="manual-wrapper">
    <div class="manual-content">
      <div v-if="suggestedManuals.length > 0" class="mt-5 mb-2">
        <h2>{{ trans('dashboard.manuals.suggested_manuals') }}:</h2>
        <manual-list :manuals="suggestedManuals" />
      </div>
      <div class="mt-5 mb-2">
        <div class="search-bar-wrapper">
          <h5 class="w-1/4">
            {{ trans('dashboard.manuals.search_application_manuals') }}
          </h5>
          <search-field :search-value="search" @search-changed="handleSearch" />
        </div>
        <div class="my-2">
          <manual-list :manuals="allManuals" />
        </div>
      </div>
      <div v-if="allFeatureManuals.length > 0" class="mt-5 mb-2">
        <h2>{{ trans('dashboard.manuals.feature_manuals') }}:</h2>
        <feature-manual-list :manuals="allFeatureManuals" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.manual {
  &-content {
    width: 90%;
    margin: 0 auto;
  }

  &-wrapper {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.search-bar {
  &-wrapper {
    display: flex;
    justify-content: flex-start;
    gap: 20px;

    & > h5 {
      margin-top: 8px;
    }
  }
}
</style>
